import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon9: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#F3123C"
        d="M3.977 11.493a.5.5 0 1 1 .772-.636c.284.346.62.726.999 1.135.202.219.416.444.639.675a65.79 65.79 0 0 0 2.518 2.457l.235.216c.475.432 1.273.432 1.748.001l.215-.197a65.95 65.95 0 0 0 2.785-2.719c.227-.238.439-.465.632-.68a.5.5 0 0 1 .743.67 39.297 39.297 0 0 1-1.155 1.218 71.257 71.257 0 0 1-2.327 2.246l-.22.202c-.857.778-2.238.777-3.094-.001l-.242-.223a65.25 65.25 0 0 1-2.556-2.495 48.31 48.31 0 0 1-.655-.69 27.136 27.136 0 0 1-1.037-1.179Zm3.437-5.392 1.662 2.493 1.57-1.569a.5.5 0 0 1 .707 0l1.854 1.854H19.5a.5.5 0 0 1 0 1H13a.5.5 0 0 1-.354-.147l-1.647-1.646-1.647 1.646a.5.5 0 0 1-.769-.076L6.896 7.127 4.993 8.765a.503.503 0 0 1-.327.121L.499 8.879a.5.5 0 0 1 .002-1l3.98.007L6.672 6a.5.5 0 0 1 .742.101ZM13.967 0c2.689 0 4.85 2.357 4.85 5.243 0 .647-.1 1.299-.295 1.958a.5.5 0 0 1-.959-.284 5.857 5.857 0 0 0 .254-1.674C17.817 2.89 16.083 1 13.967 1c-1.507 0-2.863.965-3.493 2.454a.5.5 0 1 1-.921-.39C10.335 1.217 12.044 0 13.967 0Zm-3.493 3.064a.5.5 0 0 1-.921.39C8.924 1.965 7.568 1 6.061 1 3.944 1 2.21 2.891 2.21 5.243c0 .233.015.468.046.705a.5.5 0 0 1-.992.128 6.495 6.495 0 0 1-.054-.833C1.21 2.357 3.372 0 6.061 0c1.922 0 3.632 1.217 4.413 3.064Z"
      />
    </Svg>
  )
}
